module.exports = __webpack_public_path__ + "media/images/flags/by-b8b701a17a108d0edc520a13ad51c118.svg";